module.exports = __webpack_public_path__ + "img/print_lipsprint.8ea59bf.jpg";